<template>
  <div class="pbl-container">
    <div class="banner">
      <img class="img" :src="$env.imgUrl + 'banner-pbl2.png'" alt="">
      <div class="banner-content">
        <div class="banner-title">优秀作品展厅</div>
        <div class="banner-title-en">Exhibition Hall of Excellent Works</div>
        <div class="banner-tab">
          <div class="banner-tab-item" :class="activeIndex === index ? 'sel' : ''" v-for="(item, index) in tabs" :key="index" @click="handleTabClick(index)">
            <div class="cn">{{ item.title }}</div>
            <div class="en">{{ item.enTitle }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="section1 safe-area">
      <pageTitle cn="优秀案例" en="High-level Official Reception" type="1"></pageTitle>
      <div class="common-title-d1 mt-20">经过专家评委的初步筛选，全市16区共有23个作品入围终选会。通过此次活动，培养了学生沟通协作能力，让青少年在文化的对比互鉴中，养成文化包容的胸怀和民族文化的信心。</div>
      <div class="common-title-d2 mt-12">After the preliminary screening by expert judges, a total of 23 works from 16 districts across the city were selected for the final selection meeting. Through this activity, students' communication and collaboration skills were cultivated, and young people were encouraged to develop a broad-minded attitude towards cultural inclusiveness and confidence in their national culture through cultural comparison and mutual learning.</div>
      <img class="mt-20" :src="$env.imgUrl + 'case1-s1.png'" alt="">
    </div>
    <div class="section2 common" :style="'background-image: url(' + $env.imgUrl + 'pbl-bg-1.png);'">
      <div class="safe-area">
        <pageTitle cn="美食文化类" en="Culinary Culture" type="2"></pageTitle>
        <div class="page-flex-lr-center-between">
          <div class="lf">
            <div class="title1">《德意“香”传》</div>
            <div class="school1">天津市北辰区华辰学校</div>
            <div class="common-title-d3 d3 mt-20">天津市北辰区华辰学校（初中部）的《德意“香”传》项目，以生动鲜活的演绎，深情讲述了狗不理包子创始人“狗子”的传奇一生。学生们以真挚的情感投入表演，服装、化妆、道具等细节之处无不体现出对角色的深入理解和精心打造，为观众呈现出一幅幅鲜活的历史画卷。最终，该项目以其卓越的表现和深厚的文化底蕴，荣获此次展演活动的第一名，成为了一道亮丽的风景线，彰显了青少年对传统文化的热爱与传承。</div>
            <div class="common-title-d4 d4 mt-12">The "De Yi 'Xiang' Chuan" project of Huachen School (Junior High Section) in Beichen District, Tianjin, vividly narrates the legendary life of "Gouzi", the founder of Goubuli steamed bun, through lively performances. The students invested their sincere emotions into the performances, and the details such as costumes, makeup, and props all reflected their deep understanding and meticulous creation of the characters, presenting a vivid historical picture to the audience. Ultimately, the project won the first place in this exhibition activity with its excellent performance and profound cultural connotation, becoming a beautiful scenery, highlighting the youth's love and inheritance of traditional culture.</div>
          </div>
          <div class="rt w68 page-flex-lr-center">
              <div class="video">
                <video class="video-player" :src="$env.imgUrl + 'v1.mp4'" :poster="$env.imgUrl + 'case1-s1-poster.png'" controls></video>
              </div>
              <div class="rt-img">
                <img class="s4-2" :src="$env.imgUrl + 'case1-s2-1.png'" alt="">
                <img class="s4-3" :src="$env.imgUrl + 'case1-s2-2.png'" alt="">
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="section3 common">
      <div class="safe-area">
        <pageTitle cn="美术工艺类" en="Arts and Crafts" type="1"></pageTitle>
        <div class="page-flex-lr-center-between">
          <div class="lf">
            <div class="title">《纸下的时间旅行者》</div>
            <div class="school">天津泰达实验学校</div>
            <div class="common-title-d1 d3 mt-20">天津泰达实验学校的作品《纸下的时间旅行者》以匠心独运的方式，生动讲述了天津剪纸的悠久发展历史和独特由来。该项目巧妙地将剪纸艺术融入故事情节之中，通过学生们真挚情感的演绎，展现了剪纸艺术的无穷魅力。同时，伴随着精美的剪纸服装走秀展示，服装、道具设计丰满而富有创意，为观众带来了一场视觉与心灵的双重盛宴。最终，该项目凭借其卓越的艺术表现和深厚的文化底蕴，荣获此次展演活动的第一名，充分展现了天津青少年对传统文化的热爱与传承。</div>
            <div class="common-title-d2 d4 mt-12">The work "Time Traveler Under Paper" from Tianjin TEDA Experimental School vividly narrates the long history and unique origin of Tianjin Paper Cuttings in a unique and ingenious way. The project skillfully integrates the art of Paper Cuttings into the storyline, showcasing the endless charm of Paper Cuttings through the students' sincere emotional interpretation. Simultaneously, accompanied by a beautiful Paper Cutting costume show, the clothing and prop designs are rich and creative, providing the audience with a double feast for both the eyes and the soul. Ultimately, the project won the first place in this exhibition and performance activity due to its excellent artistic expression and profound cultural heritage, fully demonstrating the love and inheritance of traditional culture by Tianjin youth.</div>
          </div>
          <div class="rt w68 page-flex-lr-center">
              <div class="video">
                <video class="video-player" :src="$env.imgUrl + 'v-zhi.mp4'" :poster="$env.imgUrl + 'case1-s2-poster.png'" controls></video>
              </div>
              <div class="rt-img">
                <img class="s4-2" :src="$env.imgUrl + 'case1-s3-1.png'" alt="">
                <img class="s4-3" :src="$env.imgUrl + 'case1-s3-2.png'" alt="">
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="section2 common" :style="'background-image: url(' + $env.imgUrl + 'pbl-bg-1.png);'">
      <div class="safe-area">
        <pageTitle cn="建筑工程类" en="Construction Engineering" type="2"></pageTitle>
        <div class="page-flex-lr-center-between">
          <div class="lf">
            <div class="title1">《翻开历史“桥”天津》</div>
            <div class="school1">天津市北辰区第二模范小学</div>
            <div class="common-title-d3 d3 mt-20">在天津市北辰区第二模范小学的精彩展演中，作品《翻开历史“桥”天津》以独特的创意和生动的表现形式，让观众仿佛穿越时空，亲身感受天津桥梁的悠久历史与独特魅力。现场，学生们巧妙地运用糖画技艺，精心制作出一座座栩栩如生的糖画桥，让桥梁的轮廓与细节在糖画的甜蜜中得以直观呈现。不仅如此，学生们还以快板这一传统艺术形式，抑扬顿挫地讲述了众多桥梁的传奇故事，将桥梁的历史与文化内涵展现得淋漓尽致。</div>
            <div class="common-title-d4 d4 mt-12">In the wonderful performance at the Second Model Primary School in Beichen District, Tianjin, the work "Opening the Historical 'Bridge' of Tianjin" presented a unique and vivid form of expression, allowing the audience to feel as if they had traveled through time and space, experiencing the long history and unique charm of Tianjin's bridges firsthand. On the scene, students skillfully utilized sugar painting techniques to carefully craft lifelike sugar painting bridges, allowing the contours and details of the bridges to be visually presented in the sweetness of sugar painting. Moreover, students also used the traditional art form of clapper talk to tell the legendary stories of numerous bridges in a cadence, fully displaying the historical and cultural connotations of the bridges.</div>
          </div>
          <div class="rt w68 page-flex-lr-center">
              <div class="video">
                <video class="video-player" :src="$env.imgUrl + 'v-qiao.MOV'" :poster="$env.imgUrl + 'case1-s3-poster.png'" controls></video>
              </div>
              <div class="rt-img">
                <img class="s4-2" :src="$env.imgUrl + 'case1-s4-1.png'" alt="">
                <img class="s4-3" :src="$env.imgUrl + 'case1-s4-2.png'" alt="">
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="section3 common">
      <div class="safe-area">
        <pageTitle cn="曲艺戏剧类" en="Performing Arts" type="1"></pageTitle>
        <div class="page-flex-lr-center-between">
          <div class="lf">
            <div class="title">《指尖上的艺术，心目中的英雄》</div>
            <div class="school">天津市蓟州区第六小学</div>
            <div class="common-title-d1 d3 mt-20">天津市蓟州区第六小学的《指尖上的艺术，心目中的英雄》展演项目，以中英双语的形式精彩呈现，将皮影戏这一古老艺术形式的魅力展现得淋漓尽致。现场，学生们通过细致入微的演绎，将皮影戏的历史与内涵娓娓道来，让观众在欣赏精彩表演的同时，也深刻感受到中华传统文化的博大精深。</div>
            <div class="common-title-d2 d4 mt-12">The exhibition and performance project "Art on Fingertips, Heroes in Mind" from the No. 6 Primary School in Jizhou District, Tianjin, was presented in bilingual Chinese and English, fully showcasing the charm of the ancient art form of shadow puppetry. At the scene, the students vividly narrated the history and connotation of shadow puppetry through their meticulous interpretation, allowing the audience to deeply appreciate the profoundness of Chinese traditional culture while enjoying the wonderful performance.</div>
          </div>
          <div class="rt w68 page-flex-lr-center">
              <div class="video">
                <video class="video-player" :src="$env.imgUrl + 'v-piying.mp4'" :poster="$env.imgUrl + 'case1-s4-poster.png'" controls></video>
              </div>
              <div class="rt-img">
                <img class="s4-2" :src="$env.imgUrl + 'case1-s5-1.png'" alt="">
                <img class="s4-3" :src="$env.imgUrl + 'case1-s5-2.png'" alt="">
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="section2 common" :style="'background-image: url(' + $env.imgUrl + 'pbl-bg-1.png);'">
      <div class="safe-area">
        <pageTitle cn="服饰纺织类" en="Apparel and Textiles" type="2"></pageTitle>
        <div class="page-flex-lr-center-between">
          <div class="lf">
            <div class="title1">《美隽成服》</div>
            <div class="school1">天津市民族中学</div>
            <div class="common-title-d3 d3 mt-20">天津市民族中学的《美隽成服》展演项目，以一场别出心裁的汉服走秀为形式，生动地呈现了汉、唐、宋、明四个朝代男女汉服的独特魅力与精细工艺。走秀现场，学生们身着各式汉服，款款走来，仿佛穿越时空，将观众带入了一个个辉煌的历史时期。</div>
            <div class="common-title-d4 d4 mt-12">The "Meijun Chengfu" performance project from Tianjin Minzu Middle School vividly showcased the unique charm and exquisite craftsmanship of Hanfu for both men and women from the Han, Tang, Song, and Ming dynasties through an ingenious Hanfu catwalk show. At the catwalk show, students dressed in various Hanfu styles walked gracefully, as if they had traveled through time and space, bringing the audience into a series of glorious historical periods.</div>
          </div>
          <div class="rt w68 page-flex-lr-center">
              <div class="video">
                <video class="video-player" :src="$env.imgUrl + 'v-fu.mp4'" :poster="$env.imgUrl + 'case1-s5-poster.png'" controls></video>
              </div>
              <div class="rt-img">
                <img class="s4-2" :src="$env.imgUrl + 'case1-s6-1.png'" alt="">
                <img class="s4-3" :src="$env.imgUrl + 'case1-s6-2.png'" alt="">
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="section3 common">
      <div class="safe-area">
        <pageTitle cn="医药文化类" en="Medical Culture" type="1"></pageTitle>
        <div class="page-flex-lr-center-between">
          <div class="lf">
            <div class="title">《大医精诚》</div>
            <div class="school">天津市西青区杨柳青第二中学</div>
            <div class="common-title-d1 d3 mt-20">参与医药文化类的队伍是天津市西青区杨柳青第二中学《大医精诚》项目，深情且详尽地讲述了古代医学巨匠孙思邈和李时珍的传奇故事，展现出他们悬壶济世、医者仁心的崇高品质。学生们以饱满的情感和生动的语言，将两位医学圣人的生平事迹娓娓道来，令听众为之动容。</div>
            <div class="common-title-d2 d4 mt-12">The team participating in the medical culture category is the "Great Medicine with Sincerity" project from Yangliuqing No.2 Middle School in Xiqing District, Tianjin. They passionately and comprehensively narrated the legendary stories of ancient medical giants Sun Simiao and Li Shizhen, showcasing their noble qualities of practicing medicine to help the world and embodying the benevolence of a doctor. With full emotion and vivid language, the students recounted the life stories of these two medical sages, deeply moving the audience.</div>
          </div>
          <div class="rt w68 page-flex-lr-center">
              <div class="video">
                <video class="video-player" :src="$env.imgUrl + 'v-dyjc.mp4'" :poster="$env.imgUrl + 'case1-s6-poster.png'" controls></video>
              </div>
              <div class="rt-img">
                <img class="s4-2" :src="$env.imgUrl + 'case1-s7-1.png'" alt="">
                <img class="s4-3" :src="$env.imgUrl + 'case1-s7-2.png'" alt="">
              </div>
            </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data () {
    return {
      activeIndex: 0,
      tabs: [
        {
          title: '非遗主题',
          enTitle: '优秀作品'
        },
        {
          title: '海洋主题',
          enTitle: '优秀作品'
        },
        {
          title: 'AI主题',
          enTitle: '优秀作品'
        },
        {
          title: '财商主题',
          enTitle: '优秀作品'
        }
      ]
    }
  },
  created() {
    this.activeIndex = this.$route.query.index ? Number(this.$route.query.index) : 0
    this.$store.dispatch('SET_MENUINDEX', 0)
  },
  watch: {
    '$route' (to) {
      this.activeIndex = to.query.index ? Number(to.query.index) : 0
    }
  },
  methods: {
    handleTabClick (index) {
      if (index === 0) {
        this.activeIndex = index
        this.$router.replace({ query: { index } })
      } else {
        this.$message.warning('暂未开放')
      }
    }
  }
}
</script>
<style scoped lang="less">
.pbl-container{
  width: 100vw;
  overflow: hidden;
}
.banner{
  width: 100vw;
  position: relative;
  min-height: 300px;
  .img{
    width: 100%;
    height: auto;
    display: block;
  }
  .banner-content{
    position: absolute;
    top: 250px;
    left: 0;
    right: 0;
    text-align: center;
  }
  .banner-title{
    color: #fff;
    font-family: regular;
    font-size: 58px;
    margin-bottom: 10px;
  }
  .banner-title-en{
    color: #fff;
    font-family: alim;
    font-size: 18px;
  }
  .banner-tab {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
    .banner-tab-item{
      margin: 20px 10px;
      width: 240px;
      height: 46px;
      border-radius: 46px;
      text-align: center;
      background-color: #fff;
      color: #000;
      cursor: pointer;
      padding-top: 8px;

      .cn{
        font-family: systh;
        font-size: 16px;
        line-height: 20px;
      }
      .en{
        font-family: systm;
        font-size: 10px;
        line-height: 16px;
      }
    }
  }
  .sel{
    background-color: #C92739 !important;
    color: #FFF !important;
  }
}

.mt-20{
  margin-top: 20px;
}
.section1{
  padding: 30px 0 40px;
  .lf{
    width: 45%;
  }
  .rt{
    flex: 1;
    margin-left: 20px;
    img{
      width: 100%;
    }
  }
}
.section2{
  padding: 60px 0 80px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.section3{
  padding: 20px 0 60px;
}
.common{
  .lf{
    width: 40%;
  }
  .rt{
    flex: 1;
    margin-left: 20px;
  }
  .video{
    width: 400px;
    height: 225px;
    margin-right: 20px;
    border-radius: 12px;
    .video-player{
      width: 400px;
      height: 225px;
      border-radius: 12px;
    }
  }
}
.rt-img{
  flex: 1;
}
.s4-2{
  width: 100%;
  height: 100px;
  margin-bottom: 20px;
  object-fit: cover;
  border-radius: 12px;
}
.s4-3{
  width: 100%;
  height: 100px;
  object-fit: cover;
  border-radius: 12px;
}
.d3{
  font-size: 12px;
}
.d4{
  font-size: 9px;
}
.title{
  font-size: 20px;
  font-family: systh;
  color: #000;
  margin-top: 20px;
}
.school{
  font-size: 14px;
  font-family: systh;
  color: #999;
}
.title1{
  font-size: 22px;
  font-family: systh;
  color: #fff;
  margin-top: 20px;
}
.school1{
  font-size: 14px;
  font-family: systh;
  color: #FD8E86;
}
</style>
